import React from "react";
import { AnimatePresence, useReducedMotion } from "framer-motion";
import {
  PAGE_TRANSITION_MOTION,
  pageTransitionVariants,
} from "../../../design-system/tokens/pageTransitionMotion";
import type { PageTransitionProps } from "./PageTransition.types";
import { MotionPageLayer, PageTransitionShell } from "./PageTransition.styles";

export const PageTransition: React.FC<PageTransitionProps> = ({
  children,
  transitionKey,
}) => {
  const reduceMotion = useReducedMotion();

  if (reduceMotion) {
    return <PageTransitionShell>{children}</PageTransitionShell>;
  }

  return (
    <PageTransitionShell>
      <AnimatePresence mode="wait" initial={false}>
        <MotionPageLayer
          key={transitionKey}
          variants={pageTransitionVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{
            duration: PAGE_TRANSITION_MOTION.durationSeconds,
            ease: PAGE_TRANSITION_MOTION.ease,
          }}
        >
          {children}
        </MotionPageLayer>
      </AnimatePresence>
    </PageTransitionShell>
  );
};
